import doveMedLogo from "../../../assets/dovemed_logo_no_shadow.png";
import doveMedLogoWebp from "../../../assets/dovemed_logo_no_shadow.webp";
import { Container } from "./Loading.styles";

export const Loading = () => {
  return (
    <Container>
      <picture>
        <source srcSet={doveMedLogoWebp} type="image/webp" />
        <source srcSet={doveMedLogo} type="image/png" />
        <img src={doveMedLogo} alt="DoveMed logo" />
      </picture>
      <div>
        <h1>DoveMap is loading...</h1>
        <p>We're doing our best to provide you the best experience. <br />Hold on tight.</p>
      </div>
    </Container>
  )
}
